import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import * as dashboardActions from "store/entities/dashboard/action";

import Table from 'components/__new/common/Table';
import Maybe from "components/__new/common/Maybe";
import PageContent from "components/__new/common/PageContent";
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import DynamicHeadTag from 'components/__new/common/DynamicHeadTag';
import pen from "assets/images/icons/pen-icon.svg";
import OnDemandPayModal from "components/__new/common/OnDemandPayModal";
import getNextSalaryDate from "utils/getNextSalaryDate";
import {getOrdinalSuffix} from "utils/getNextSalaryDate";

import {capitalizeFirstLetter} from "utils/stringFormatter";
import ReactTooltip from 'react-tooltip'
// import { ReactComponent as IconInfo } from "assets/images/icons/project-icons/question-icon.svg";
import { ReactComponent as IconInfo } from "assets/images/icons/project-icons/caution.svg";



const OnDemandPay = () => {
  const dispatch = useDispatch();
  const { companyInfo, companyInfoLoading } = useSelector((s) => s.entities.settingsInfo);
  const {dashboard, dashboardLoading} = useSelector(state => state.entities.dashboard);
  const hasOdpEnabled = dashboard?.employer?.products?.includes("ON_DEMAND_PAY")
  
  
  const { InlineRouterTab } = useInlinePageRouter();
  const [editOnDemandPayModal, setEditOnDemandPayModal] = useState(false);
  
  const queryOptions = [
    {
        title: "Profile Information",
        path: "/settings/profile"
        
    },
    {
        title: "Company Details",
        path: "/settings/info"           
    },
    {
        title: "Teams",
        path: "/settings/team-management",
        
    },
    {
        title: "Role Management",
        path: "/settings/team-management/roles",
        
    },
    {
        title: "On-Demand Pay",
        path: "/settings/ondemand-pay",
        
    },
    {
        title: "Login & Security",
        path: "/settings/login-security",
       
    },
    // {
    //     title: "Notifications",
    //     path: "/settings/notifications",
       
    // },
]

useEffect(() => {
  dispatch(dashboardActions.getDashboard())
  
}, []
)



  return (
    <div> 
      
      <DynamicHeadTag
        headerText="On-Demand Pay | Settings"
        headerDescription="Manage your On-Demand Pay settings here."
      />
        
      <OnDemandPayModal 
        isOpen={editOnDemandPayModal}
        setIsOpen={setEditOnDemandPayModal}
      />
        
            
      <div className="lg:flex">
          <div className="w-full lg:w-1/2">
              <div className="page-title text-ep-deep-dark">
                  Settings
              </div>
          </div>
          <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
      </div>
      
      <div className="mt-6 w-full">
        <InlineRouterTab
            items={queryOptions}
        />
      </div>
      
      <div className="mt-6 p-4 sm:p-6 bg-white" style={{borderRadius: '12px'}}>
                <div className='flex justify-between items-center mb-8 mt-3'>
                  <div>
                    <div className='font-bold text-ep-black' style={{fontSize: '18px', lineHeight: '21.6px'}}>On-Demand Pay Configuration</div>
                    <div className='text-ep-gray-600 pr-6' style={{fontWeight: 400, fontSize: '16px', lineHeight: '19.2px'}}>Configure your On-Demand Pay settings</div>
                  </div>
                  <div> 
                    <button type="button" className="text-ep-primary-600 font-medium underline flex text-right justify-end" onClick={() => setEditOnDemandPayModal(true)}><img src={pen} alt="pen-icon"/>Edit</button>
                  </div>
                </div>
             <PageContent
                loading={dashboardLoading}
                data={dashboard}
                loadingText="Loading ODP information..."
                emptyText="ODP information not found"
                errorText="Unable to fetch ODP information"
            />
             <Maybe condition={dashboardLoading === false && (hasOdpEnabled === true)}>
             <div className="mt-10 border border-gray-200 rounded-lg">
                <Table className="w-full mb-6">
                    <Table.Body>
                        <tr>
                            <td style={{border: '0px', backgroundColor: 'transparent',  width: "200px", color: '#4A5564', fontSize: '16px', lineHeight: '19.2px'}} className="">Salary Date</td>
                            <td style={{border: '0px', backgroundColor: 'transparent', fontSize: '16px', lineHeight: '19.2px', color: '#1A202C'}} className="font-medium">{companyInfo?.company?.payrollCutOff ? getNextSalaryDate(companyInfo?.company?.payrollCutOff) : "-"}</td>
                        </tr>
                        <tr>
                            <td style={{border: '0px', backgroundColor: 'transparent', width: "200px", color: '#4A5564', fontSize: '16px', lineHeight: '19.2px'}} className="">Withdrawal Fee</td>
                            <td style={{border: '0px', backgroundColor: 'transparent', fontSize: '16px', lineHeight: '19.2px', color: '#1A202C'}} className="font-medium">{capitalizeFirstLetter(companyInfo?.company?.paymentFee)}</td>
                        </tr>
                        <tr>
                            <td style={{border: '0px', backgroundColor: 'transparent', width: "200px", color: '#4A5564', fontSize: '16px', lineHeight: '19.2px'}} className="">Withdrawal Setup</td>
                            <td style={{border: '0px', backgroundColor: 'transparent', fontSize: '16px', lineHeight: '19.2px', color: '#1A202C'}} className="font-medium">
                                {companyInfo?.company?.autoWithdrawals === true ? 'Allow Auto Withdrawal' : 'Require Approval'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{border: '0px', backgroundColor: 'transparent', width: "200px", color: '#4A5564', fontSize: '16px', lineHeight: '19.2px'}} className="">Employee Access</td>
                            <td style={{border: '0px', backgroundColor: 'transparent', fontSize: '16px', lineHeight: '19.2px', color: '#1A202C'}} className="font-medium">
                                {companyInfo?.company?.withdrawalPercent && companyInfo?.company?.withdrawalPercent + '%'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{border: '0px', backgroundColor: 'transparent',  width: "200px", color: '#4A5564', fontSize: '16px', lineHeight: '19.2px'}} className=" w-full relative">
                              <span className='flex items-center gap-2'> 
                                <span>Cut-Off date</span>
                                <button type="button" data-tip data-for="cut-off-date" className='pr-2 cursor-pointer'><IconInfo /></button>
                              </span>
                              <ReactTooltip  place='bottom' id="cut-off-date" type='light' backgroundColor='#fff' className="tooptip-size text-center py-3 px-4 rounded-2.5 text-ep-gray-300">
                                <div style={{maxwidth: "456px", fontSize: '16px', lineHeight: '19.2px' }}>
                                  Your On-Demand Pay cut-off date is the {companyInfo?.company?.payrollCutOff ? companyInfo?.company?.payrollCutOff - 2 + getOrdinalSuffix(companyInfo?.company?.payrollCutOff - 2) : ""}, two days<br /> before salary day. From this date, employees can't<br /> withdraw money using On-Demand Pay.
                                </div>
                            </ReactTooltip>
                            </td>
                            <td style={{border: '0px', backgroundColor: 'transparent', fontSize: '16px', lineHeight: '19.2px', color: '#1A202C'}} className="font-medium">{companyInfo?.company?.payrollCutOff ? getNextSalaryDate(companyInfo?.company?.payrollCutOff - 2) : "-"}</td>
                        </tr>
                    </Table.Body>
                </Table>
            </div>
                {/* Former View */}
                {/* <div className='border border-gray-200 p-5 rounded-md mt-5 pr-10'>
                  <div className='flex my-3'>
                    <div>
                      <div className='pr-10 text-ep-gray-500'>Salary Date</div>
                    </div>
                    <div>
                      <div className='pl-10 font-medium'>{getNextSalaryDate(companyInfo?.company?.payrollCutOff)}</div>
                    </div>
                  </div>
                    
                  <div className='flex my-4'>
                    <div>
                      <div className='pr-10 text-ep-gray-500'>Withdrawal Fee</div>
                    </div>
                    <div>
                      <div className='pl-4 font-medium'>{capitalizeFirstLetter(companyInfo?.company?.paymentFee)}</div>
                    </div>
                  </div>
                    
                  <div className='flex my-4'>
                    <div>
                      <div className='pr-5 text-ep-gray-500'>Withdrawal Setup</div>
                    </div>
                    <div>
                      <div className='pl-4 font-medium'>{companyInfo?.company?.autoWithdrawals === true ? 'Allow Auto Withdrawal' : 'Require Approval'}</div>
                    </div>
                  </div>
                    
                  <div className='flex my-3'>
                    <div>
                      <div className='pr-5 text-ep-gray-500'>Employee Access</div>
                    </div>
                    <div>
                      <div className='pl-4 font-medium'>{companyInfo?.company?.withdrawalPercent && companyInfo?.company?.withdrawalPercent + '%'}</div>
                    </div>
                  </div>
                </div> */}
              </Maybe>
      </div>
        
    </div>
  )
}

export default OnDemandPay
